import { Dropdown, MenuProps } from "antd";
import "./account-menu.css";
import { UserAvatar, UserAvatarWithDetails } from "components/user-avatar";
import { getIsSSOLogin, getUser } from "services/auth";
import { endSession } from "services/session-manager";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import LogoutIcon from "components/svg-icons/logout-icon";
import { useUserProfileInfo } from "hooks/users";

function AccountMenu() {
  const [currentUser]: [any, any] = useState(getUser());
  const [userInfo, setUserInfo] = useState<any>();
  const { data: userData } = useUserProfileInfo(currentUser?.email);
  const history = useHistory();
  const isSSOLogin = getIsSSOLogin();

  useEffect(() => {
    if (!userData) return;
    if (userData.subscription_users.length > 0) {
      setUserInfo(userData.subscription_users[0]);
    }
  }, [userData]);

  const changePassword = () => {
    history.push("/change_password");
  };

  const menuItems: MenuProps["items"] = [
    {
      key: "profile",
      // antd v6 nests its dropdown rules (`.ant-dropdown .ant-dropdown-menu
      // .ant-dropdown-menu-item`), out-specifying plain Tailwind utilities that
      // won on source order under v4 — hence the `!` modifiers here and below.
      className: "!px-2",
      label: (
        <UserAvatarWithDetails
          showAvatar={false}
          dataTestId="account-menu-profile-avatar"
          fullName={
            userInfo
              ? `${userInfo?.user?.first_name} ${userInfo?.user?.last_name}`
              : undefined
          }
          email={currentUser?.email}
          subscription={userInfo?.subscription?.name || ""}
        />
      )
    },
    ...(!isSSOLogin
      ? ([
          { type: "divider", className: "!bg-ciq-gray-950-a50" },
          {
            key: "change-password",
            className: "h-6",
            label: (
              <div
                className="h-6 w-full ml-2 text-[10px] font-normal text-ciq-gray-950-a80"
                onClick={changePassword}
                data-testid="change-password-button"
                role="button"
                tabIndex={0}
                onKeyDown={() => {}}
              >
                Change Password
              </div>
            )
          }
        ] as NonNullable<MenuProps["items"]>)
      : []),
    {
      key: "sign-out",
      className: "!p-0",
      label: (
        <div
          onClick={() => endSession("user_initiated")}
          className="flex w-full h-6 items-center justify-between bg-ciq-gray-200 px-4 cursor-pointer"
          data-testid="logout-button"
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
        >
          <div className="flex h-full items-center font-semibold text-xs text-ciq-gray-950">
            Logout
          </div>
          <LogoutIcon />
        </div>
      )
    }
  ];

  return (
    <Dropdown
      arrow
      placement="bottomRight"
      // `overflow-hidden` clips the flush Logout bar to the menu's v6 corner
      // radius (v4's radius was 2px, so the square band went unnoticed).
      menu={{
        items: menuItems,
        className: "!p-0 space-y-1 overflow-hidden"
      }}
      trigger={["click"]}
      data-testid="index-dropdown"
    >
      <div
        data-cy="account"
        data-testid="account-menu-trigger"
        className="accMenuContainer cursor-pointer"
      >
        <UserAvatar
          url=""
          isRect={false}
          dataTestId="account-menu-avatar"
          fullName={
            userInfo
              ? `${userInfo?.user?.first_name} ${userInfo?.user?.last_name}`
              : ""
          }
        />
      </div>
    </Dropdown>
  );
}

export default AccountMenu;
